import { QueryClient } from "@tanstack/react-query";

const EXPIRATION_TIME_5_MINUTES = 5 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 0,
      gcTime: EXPIRATION_TIME_5_MINUTES,
    },
  },
});
